import React from 'react';

import {
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { MdClose, MdSearch } from 'react-icons/md';

import { SearchInputProps } from './SearchInput.props';

/** Matches the API's limit on the `search` query param. */
export const SEARCH_MAX_LENGTH = 100;

/**
 * Text search box for list pages: shows a search icon while empty and a clear
 * button once there is text. Callers debounce the value before querying.
 */
const SearchInput: React.FC<SearchInputProps> = (props) => {
  const { value, onChange, placeholder = 'Search' } = props;

  return (
    <InputGroup mb={5} w="100%" maxW="320px">
      <Input
        placeholder={placeholder}
        aria-label={placeholder}
        maxLength={SEARCH_MAX_LENGTH}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <InputRightElement>
        {value ? (
          <IconButton
            size="sm"
            variant="ghost"
            aria-label="Clear search"
            icon={<MdClose size="18px" />}
            onClick={() => onChange('')}
          />
        ) : (
          <MdSearch fill="#2FB64A" />
        )}
      </InputRightElement>
    </InputGroup>
  );
};

export default SearchInput;
